<div class="kal-stepper-header-container">
  @for(step of steps; track step.index()) {
    <kal-step-header
      (click)="step.select()"
      (keydown)="_onKeydown($event)"
      [active]="step.completed || step.isSelected() || !linear"
      [attr.aria-controls]="_getStepContentId(step.index())"
      [attr.aria-label]="step.ariaLabel || null"
      [attr.aria-labelledby]="(!step.ariaLabel && step.ariaLabelledby) ? step.ariaLabelledby : null"
      [attr.aria-posinset]="step.index() + 1"
      [attr.aria-selected]="step.isSelected()"
      [attr.aria-setsize]="steps.length"
      [id]="_getStepLabelId(step.index())"
      [index]="step.index()"
      [label]="step.stepLabel"
      [optional]="step.optional"
      [selected]="step.isSelected()"
      [state]="step.indicatorType()">
    </kal-step-header>
  }
</div>

<div class="kal-content-container">
    @for(step of steps; track step.index()) {
      <div [attr.aria-expanded]="step.isSelected()"
           [attr.aria-labelledby]="_getStepLabelId(step.index())"
           [id]="_getStepContentId(step.index())"
           class="kal-stepper-content"
           role="tabpanel">
        <ng-container [ngTemplateOutlet]="step.content"></ng-container>
      </div>
    }
</div>
